import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as nextReducer from "containers/Next/NextReducer";

import LeakageChart from "components/Next/Charts/LeakageChart";

const getId = (props) =>
  props && props.id
    ? props.id
    : props.datasetId
      ? props.datasetId
      : props && props.match && props.match.params && props.match.params.datasetId
        ? props.match.params.datasetId
        : "new";

class LeakageChartContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    const { node, isReport, hoverGroup, tempDatasetId } = this.props;

    return tempDatasetId !== nextProps?.tempDatasetId
      ? true
      : node !== undefined && node?.chart?.narrative?.title !== nextProps?.node?.chart?.narrative?.title
        ? true
        : node?.narrative?.title !== undefined && node?.narrative?.title !== nextProps?.node?.narrative?.title
          ? true
          : node !== undefined
            ? false
            : true;
  }

  render() {
    return <LeakageChart {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    handleMuscleClick: (field) => dispatch(nextReducer.handleMuscleClick(id, field))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const datasetId = ownProps?.datasetId || nextReducer.getDatasetId(state, id);
  const isReport = ownProps.isReport;
  const isExploreTask = ownProps.isExploreTask;

  return ownProps?.node || isReport || isExploreTask
    ? {
        id: id,
        dataset: homeReducer.getDataset(state, datasetId),
        rankedFields: homeReducer.getRankedFields(state, datasetId),

        gridType: nextReducer.getGridType(state, id),

        tempDatasetId: nextReducer.getTempDatasetId(state, id),

        ...nextReducer.getHoverFromNode(
          state,
          ownProps?.node ? ownProps.node : isExploreTask ? ownProps?.node : ownProps?.node?.chart
        )
      }
    : {
        id: id,
        dataset: homeReducer.getDataset(state, datasetId),
        rankedFields: homeReducer.getRankedFields(state, datasetId),

        hoverGroup: nextReducer.getHoverGroup(state, id),
        hoverRibbon: nextReducer.getHoverRibbon(state, id),
        hoverNode: ownProps.hoverNode !== undefined ? ownProps?.hoverNode : nextReducer.getHoverNode(state, id),

        gridType: nextReducer.getGridType(state, id),
        searchOptions: nextReducer.getSearchOptions(state, id),

        tempDatasetId: nextReducer.getTempDatasetId(state, id),

        isHideSearch: nextReducer.getIsHideSearch(state, id)
      };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(LeakageChartContainer);
